import React from 'react';
import { IDockviewPanelProps } from 'dockview';

import NetworkViewerTab from '../tabs/NetworkViewerTab';
import ComponentSpecificationsTab2 from '../tabs/ComponentSpecificationsTab2';
import AsBuiltViewerTab from '../tabs/AsBuiltViewerTab';
import SitesTableTab from '../tabs/SitesTableTab';
import ExtractionDataTab from '../tabs/ExtractionDataTab';
import UserProfileTab from '../tabs/UserProfileTab';
import AdminViewTab from '../tabs/AdminViewTab';
import QAExecutiveSummaryTab from '../tabs/QAExecutiveSummaryTab';
import QuestionSetsTab from '../tabs/QuestionSetsTab';
import PageListTab from '../tabs/PageListTab';
import QuestionSummaryTab from '../tabs/QuestionSummaryTab';
import NomenclatureTab from '../tabs/NomenclatureTab';
import CrossPageTab from '../tabs/CrossPageTab';
import PageReferencesTab from '../tabs/PageReferencesTab';
import EventsTasksTab from '../tabs/EventsTasksTab';
import InteractiveTimelineTab from '../tabs/InteractiveTimelineTab';
import SiteDetailsTab from '../tabs/SiteDetailsTab';
import PortfolioComponentsTab from '../tabs/PortfolioComponentsTab';
import PortfolioMapTab from '../tabs/PortfolioMapTab';
import PortfolioDashboardTab from '../tabs/PortfolioDashboardTab';
import SiteAnalysisTab from '../tabs/SiteAnalysisTab';
import ProjectInboxTab from '../tabs/ProjectInboxTab';
import DataroomTab from '../tabs/DataroomTab';
import HomeLandingTab from '../tabs/HomeLandingTab';
import PortfolioEventsCalendarTab from '../tabs/PortfolioEventsCalendarTab';
import SiteMapTab from '../tabs/SiteMapTab';
import ContractsTab from '../tabs/ContractsTab';


// Single source of truth for all tab configurations
export const tabRegistry = {
  home: {
    title: 'Home',
    component: (() => <HomeLandingTab />) as React.FC<IDockviewPanelProps>,
    route: '/',
  },
  portfoliodashboard: {
    title: 'Portfolio Dashboard',
    component: (() => <PortfolioDashboardTab />) as React.FC<IDockviewPanelProps>,
    route: '/portfolio-dashboard',
  },
  siteanalysis: {
    title: 'Site Analysis',
    component: (() => <SiteAnalysisTab />) as React.FC<IDockviewPanelProps>,
    route: '/site-analysis',
  },
  sitedetails: {
    title: 'Site Details',
    component: (() => <SiteDetailsTab />) as React.FC<IDockviewPanelProps>,
    route: '/site-details',
  },
  eventstasks: {
    title: 'Events & Tasks',
    component: (() => <EventsTasksTab />) as React.FC<IDockviewPanelProps>,
    route: '/events',
  },
  interactivetimeline: {
    title: 'Timeline Analysis',
    component: (() => <InteractiveTimelineTab />) as React.FC<IDockviewPanelProps>,
    route: '/timeline',
  },
  networkviewer: {
    title: 'Network View',
    component: (() => <NetworkViewerTab />) as React.FC<IDockviewPanelProps>,
    route: '/network-viewer',
  },
  componentlist: {
    title: 'Component View',
    component: (() => <ComponentSpecificationsTab2 />) as React.FC<IDockviewPanelProps>,
    route: '/component-view',
  },
  asbuilt: {
    title: 'As-Built View',
    component: (() => <AsBuiltViewerTab />) as React.FC<IDockviewPanelProps>,
    route: '/as-built-viewer',
  },
  sitestable: {
    title: 'Sites',
    component: (() => <SitesTableTab />) as React.FC<IDockviewPanelProps>,
    route: '/sites',
  },
  extractiondata: {
    title: 'Extraction Report',
    component: (() => <ExtractionDataTab />) as React.FC<IDockviewPanelProps>,
    route: '/extraction-report',
  },
  userprofile: {
    title: 'User Profile',
    component: (() => <UserProfileTab />) as React.FC<IDockviewPanelProps>,
    route: '/user-profile',
  },
  adminview: {
    title: 'Admin View',
    component: (() => <AdminViewTab />) as React.FC<IDockviewPanelProps>,
    route: '/admin',
  },
  qaexecutivesummary: {
    title: 'Executive Summary',
    component: (() => <QAExecutiveSummaryTab />) as React.FC<IDockviewPanelProps>,
    route: '/qa-executive-summary',
  },
  questionsets: {
    title: 'Question Set',
    component: (() => <QuestionSetsTab />) as React.FC<IDockviewPanelProps>,
    route: '/question-sets',
  },
  pagelist: {
    title: 'Page List',
    component: (() => <PageListTab />) as React.FC<IDockviewPanelProps>,
    route: '/page-list',
  },
  questionsummary: {
    title: 'Answers Summary',
    component: (() => <QuestionSummaryTab />) as React.FC<IDockviewPanelProps>,
    route: '/question-summary',
  },
  nomenclature: {
    title: 'Nomenclature Validation',
    component: (() => <NomenclatureTab />) as React.FC<IDockviewPanelProps>,
    route: '/nomenclature',
  },
  crosspage: {
    title: 'Cross-Page Validation',
    component: (() => <CrossPageTab />) as React.FC<IDockviewPanelProps>,
    route: '/cross-page',
  },
  pagereferences: {
    title: 'Page References',
    component: (() => <PageReferencesTab />) as React.FC<IDockviewPanelProps>,
    route: '/page-references',
  },
  portfoliocomponents: {
    title: 'Portfolio Components',
    component: (() => <PortfolioComponentsTab />) as React.FC<IDockviewPanelProps>,
    route: '/portfolio-components',
  },
  portfoliomap: {
    title: 'Portfolio Map',
    component: (() => <PortfolioMapTab />) as React.FC<IDockviewPanelProps>,
    route: '/portfolio-map',
  },
  projectinbox: {
    title: 'Project Inbox',
    component: (() => <ProjectInboxTab />) as React.FC<IDockviewPanelProps>,
    route: '/inbox',
  },
  dataroom: {
    title: 'Dataroom',
    component: (() => <DataroomTab />) as React.FC<IDockviewPanelProps>,
    route: '/dataroom',
  },
  portfolioeventscalendar: {
    title: 'Portfolio Events Calendar',
    component: (() => <PortfolioEventsCalendarTab />) as React.FC<IDockviewPanelProps>,
    route: '/portfolio-events-calendar',
  },
  sitemap: {
    title: 'Site Map',
    component: (() => <SiteMapTab />) as React.FC<IDockviewPanelProps>,
    route: '/site-map',
  },
  contracts: {
    title: 'Contracts',
    component: (() => <ContractsTab />) as React.FC<IDockviewPanelProps>,
    route: '/contracts',
  },
} as const;

// Derived exports for backward compatibility
export const dockviewComponents = Object.fromEntries(
  Object.entries(tabRegistry).map(([key, config]) => [key, config.component])
);

export const tabConfigs: Record<string, { title: string; component: string }> = Object.fromEntries(
  Object.entries(tabRegistry).map(([key, config]) => [key, { title: config.title, component: key }])
);

export const getTabTitle = (tabType: string): string => {
  return tabRegistry[tabType as keyof typeof tabRegistry]?.title || tabType;
};

export const tabToRoute: Record<string, string> = Object.fromEntries(
  Object.entries(tabRegistry).map(([key, config]) => [key, config.route])
);

export const routeToTab: Record<string, string> = Object.fromEntries(
  Object.entries(tabRegistry).map(([key, config]) => [config.route, key])
);
